import { FC } from 'react';
import { Row, styled } from '@streem/ui-react';
import { useCallRequeue } from '../../../hooks/use_call_requeue';
import { MemberAndItems } from './call_detail_member_and_items';
import { CollapsibleContent } from './collapsible_content';
import { CallDetailDiagnosis } from './call_detail_diagnosis';
import { CallDetailTransferred } from './call_detail_transferred';
import { CallDetailHeader } from './header/call_detail_header';
import { CallDetailNotes } from './call_detail_notes';
import { useCompanySettingsStore } from '../../../hooks/use_global_context';

export const CallDetailForReservation: FC = () => {
    const { callRequeueEnabled } = useCallRequeue();
    const companySettings = useCompanySettingsStore();
    const noteEditorEnabled = companySettings.editorNotesEnabled;

    return (
        <section>
            <CallDetailHeader />
            {noteEditorEnabled && <CallDetailNotes />}
            <CollapsibleContent title="Call Details" id="post-call-details">
                <MemberAndItems />
                <CallDetailWrapper>
                    <CallDetailDiagnosis />
                    {callRequeueEnabled && <CallDetailTransferred />}
                </CallDetailWrapper>
            </CollapsibleContent>
        </section>
    );
};

const CallDetailWrapper = styled(Row)({
    columnGap: '2rem',
});
